module.exports = __webpack_public_path__ + "static/media/Ellipse 116.185a6e51.png";